module.exports = __webpack_public_path__ + "img/index-cover-desktop.cedf447c.png";